import React from "react";
import { ListSection } from "./ListSection";
import {
  InvestmentService,
  investTradeItems,
  noticeBoardItems,
  platformItems,
  researchItems,
  servicesLinks,
} from "./navbarConstants";
import { toAbsoluteUrl } from "../../../assets/helpers/AssetHelpers";
import { Link } from "react-router-dom";
import "./subNavbar.css";
const SubNavbar = () => {
  return (
    <>
      <section className="bg-color42" id="sub-navbar">
        <div className="container">
          <div className="row">
            <div className="col">
              <div className="row">
                <div className="col-lg-11 mx-auto px-4 px-md-5 px-lg-1">
                  <nav className="navbar navbar-expand-xl d-none d-xl-block p-0">
                    <div className="container p-0 ">
                      <button
                        className="navbar-toggler border-0 px-0 d-none"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarSupportedContent"
                        aria-controls="navbarSupportedContent"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                        // onClick={toggleNavbarState}
                      >
                        <span className="navbar-toggler-icon"></span>
                      </button>
                      <div className="d-none">
                        <div className="me-3 d-none d-sm-block d-xl-none">
                          <a
                            href={`${process.env.REACT_APP_MAIN_WEBSITE_URL}open-demat-account/`}
                            target="_blank"
                            className="btn-font-12 bg-color29 nav-btn btn px-4 rounded-3 w-100 py-2 text-white "
                          >
                            Open Demat Account
                          </a>
                        </div>
                        <button
                          className="btn btn_outline fs-3 d-block d-xl-none p-0"
                          type="button"
                          data-bs-toggle="offcanvas"
                          data-bs-target="#offcanvasExample"
                          aria-controls="offcanvasExample"
                        >
                          <i className="fas fa-bars"></i>
                        </button>
                      </div>
                      <div
                        className="collapse navbar-collapse nav-mar-collapse "
                        id="navbarSupportedContent"
                      >
                        <div className="" style={{ width: "190px" }}></div>
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                          <li className="nav-item nav_item nav-item-mar  dropdown">
                            <a
                              className="nav-link nav-link-font  dropdown-toggle in_reg fs-14 px-lg-3 color28"
                              href="#"
                              role="button"
                              // data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              Product <i className="fa-solid fa-chevron-down ms-1"></i>
                            </a>
                            <div
                              className="dropdown-menu dropdown_menu nav-pad border-0 dropdown-menu-shadow z-index-1000 show"
                              data-bs-popper="static"
                            >
                              <div className="product-menu-grid">
                                <div className="mt-4 mt-lg-0">
                                  <ListSection title="Platform" items={platformItems} />
                                  <ListSection title="Services" items={servicesLinks} />
                                </div>
                                <div>
                                  <ListSection title="Invest & Trade" items={investTradeItems} />
                                </div>
                                <div>
                                  <ListSection
                                    title="Investment Service"
                                    items={InvestmentService}
                                  />
                                </div>
                                <div>
                                  <div className="d-flex justify-content-end ">
                                    <img
                                      className="d-none d-lg-block"
                                      src={toAbsoluteUrl(
                                        "herosection-images/ProductNavbarCard.svg",
                                      )}
                                      alt=""
                                    />
                                  </div>
                                  <a
                                    href={`${process.env.REACT_APP_MAIN_WEBSITE_URL}indian-options-conclave-7-0/`}
                                    className="d-flex justify-content-end mt-3"
                                  >
                                    <img
                                      className="d-none d-lg-block"
                                      src={toAbsoluteUrl("herosection-images/ioc.svg")}
                                      alt=""
                                    />
                                  </a>
                                </div>
                              </div>
                            </div>
                          </li>
                          <li className="nav-item nav_item nav-item-mar  dropdown">
                            <a
                              className="nav-link nav-link-font  dropdown-toggle in_reg fs-14 px-lg-3 color28"
                              href="#"
                              role="button"
                              // data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              Resources <i className="fa-solid fa-chevron-down ms-1"></i>
                            </a>
                            <ul
                              className="dropdown-menu dropdown_menu nav-pad-x border-0 rounded-0 dropdown-menu-shadow z-index-1000 show"
                              data-bs-popper="static"
                            >
                              <div className="row gx-0 pt-3 pt-lg-0">
                                <div className="col-lg-3 nav-pad-y">
                                  <ListSection title="Research" items={researchItems} />
                                </div>
                                <div className="col-lg-3 nav-pad-y">
                                  <ListSection title="Notice Board" items={noticeBoardItems} />
                                </div>
                                <div className="col-lg-6 active-bg">
                                  <div className="active-bg px-3 nav-pad-y h-100 d-none d-xl-block">
                                    <div>
                                      <a
                                        className="fs-18 in_semi mb-4 lh-22 color28 li-link"
                                        role="button"
                                        href={`${process.env.REACT_APP_MAIN_WEBSITE_URL}news/`}
                                      >
                                        News
                                      </a>
                                      <div className="fs-12 in_reg my-2">
                                        Get to know the rationale behind great ideas for you to make
                                        sound long term investment decisions.
                                      </div>
                                    </div>
                                    <div className="mt-3">
                                      <a
                                        className="fs-18 in_semi mb-4 lh-22 color28 li-link"
                                        role="button"
                                        href={`${process.env.REACT_APP_MAIN_WEBSITE_URL}blog/`}
                                      >
                                        Blogs
                                      </a>
                                      <div className="fs-12 in_reg my-2">
                                        Explore our blogs and guides to gain insights and learn how
                                        to get started with trading and investments.
                                      </div>
                                    </div>
                                    <div className="mt-3">
                                      <a
                                        className="fs-18 in_semi mb-4 lh-22 color28 li-link"
                                        role="button"
                                        href="https://support.jainam.in/"
                                      >
                                        FAQs
                                      </a>
                                      <div className="fs-12 in_reg my-2">
                                        Find answers to your questions with our comprehensive set of
                                        FAQs. If you need further assistance, our Support team is
                                        here to help!
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </ul>
                          </li>
                          <li className="nav-item nav_item nav-item-mar ">
                            <a
                              className="nav-link nav-link-font  dropdown-toggle in_reg fs-14 px-lg-3 color28"
                              href="https://jainam.in/pricing/"
                            >
                              Pricing
                            </a>
                          </li>

                          <li className="nav-item nav_item nav-item-mar dropdown">
                            <a
                              className="nav-link nav-link-font in_reg fs-14 px-lg-3 color28 dropdown-toggle"
                              href="#"
                              role="button"
                              onClick={(e) => e.preventDefault()}
                            >
                              Support <i className="fa-solid fa-chevron-down ms-1"></i>
                            </a>
                            <ul className="dropdown-menu support-dropdown border-0 shadow-sm z-index-1000 top-100">
                              <li>
                                <a
                                  className="dropdown-item dropdown-item-support"
                                  href="https://jainam.in/contact-us/"
                                >
                                  Contact Us
                                </a>
                              </li>
                              <li>
                                <a
                                  className="dropdown-item dropdown-item-support"
                                  href="https://support.jainam.in"
                                >
                                  FAQs
                                </a>
                              </li>
                              <li>
                                <a
                                  className="dropdown-item dropdown-item-support"
                                  href={`${process.env.REACT_APP_MAIN_WEBSITE_URL}forms/`}
                                >
                                  Downloads
                                </a>
                              </li>
                              <li>
                                <a
                                  className="dropdown-item dropdown-item-support"
                                  href={`${process.env.REACT_APP_URL}videos/`}
                                >
                                  Knowledge Base
                                </a>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SubNavbar;
